
import {Component, Vue} from "vue-property-decorator";


@Component
export default class HomeClass extends Vue {


    public more(){
        this.$emit('more')
    }

}
